const rrfProps = (firebase,store) => {
  return {
    firebase,
    config: {
      userProfile: "users",
      presence: "presence", // where list of online users is stored in database
      // sessions: 'sessions', // where list of user sessions is stored in database (presence must be enabled)
      profileParamsToPopulate: [
        { child: "role", root: "roles" }, // populates user's role with matching role object from roles
      ],
      profileFactory: (user) => {
        const profile = {
          email: user.email || user.providerData[0].email,
          displayName: user.providerData[0].displayName,
          avatarUrl: user.providerData[0].photoURL,
          role: 0,
        };
        if (user.providerData && user.providerData.length) {
          profile.providerData = user.providerData;
        }
        return profile;
      },
    },
    dispatch: store.dispatch,
  };
};
export default rrfProps;
